import { GATEWAY, http } from '@/utils/request';

/**
 * 上传单个文件
 * @param file 文件对象
 * @returns 上传结果
 */
export interface UploadResponse {
  filename: string;
  storagePath: string;
}
export const uploadFile = (file: File) => {
  const formData = new FormData();
  formData.append('file', file.raw);
  return http.post<UploadResponse>(`${GATEWAY.FILE}/files/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

/**
 * 分片上传初始化
 * @param params 初始化信息
 * @returns 初始化结果
 */
export interface ChunksInitParams {
  srcFileSuffix: string;
  srcFileName: string;
  srcFileSize: number;
  chunkSize: number;
  srcFileMd5: string;
  callbackUrl?: string;
  autoMerge?: boolean;
  autoDecompress?: boolean;
  extParam?: string;
}
export interface ChunksInitResponse {
  destFilepath: string;
  destFilename: string;
  decompressedPath: string;
  uploadedChunks: number[];
  uploadToken: string;
  uploadId: string;
}
export const dynamicChunksInit = (params: ChunksInitParams) => {
  return http.post<ChunksInitResponse>(`${GATEWAY.FILE}/dynamic/chunks/init`, params);
};

/**
 * 分片上传
 * @param params 分片上传信息
 * @returns 分片上传结果
 */
// export interface ChunksUploadFormData {
//   file: File;
//   uploadToken: string;
//   chunkIndex: number;
// }
export interface ChunksUploadResponse {
  chunkIndex: number;
  chunkSize: number;
  chunkMd5: string;
}
export const dynamicChunksUpload = (formData: FormData) => {
  return http.post<ChunksUploadResponse>(`${GATEWAY.FILE}/dynamic/chunks/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
